import { MrModalDialog } from '@mrhenry/wp--mr-interactive';

export class MrNavigationOverlay extends MrModalDialog {
	#pausedVideos = new WeakSet();

	override async willOpen() {
		await super.willOpen();

		document.body.classList.add( 'is-showing-modal-dialog' );
		document.documentElement.classList.add( 'is-showing-modal-dialog' );

		setTimeout( () => {
			this.setAttribute( 'data-animation-start', '' );
		}, 48 );
	}

	override async didOpen(): Promise<void> {
		await super.didOpen();

		this.pauseAllBackgroundVideos();
	}

	override async willClose() {
		await super.willClose();

		document.body.classList.remove( 'is-showing-modal-dialog' );
		document.documentElement.classList.remove( 'is-showing-modal-dialog' );

		this.removeAttribute( 'data-animation-start' );
	}

	override async didClose(): Promise<void> {
		await super.didClose();

		this.unpauseAllBackgroundVideos();
	}

	override openAnimations() {
		if ( !( 'KeyframeEffect' in window ) ) {
			return [];
		}

		return [
			new KeyframeEffect(
				this.querySelector( '.modal-dialog__content' ),
				[
					{
						opacity: '0',
					},
					{
						opacity: '1',
					},
				],
				{
					duration: 96,
					easing: 'ease-in',
					fill: 'forwards',
				}
			),
		];
	}

	override closeAnimations() {
		if ( !( 'KeyframeEffect' in window ) ) {
			return [];
		}

		return [
			new KeyframeEffect(
				this.querySelector( '.modal-dialog__content' ),
				[
					{
						opacity: '1',
					},
					{
						opacity: '0',
					},
				],
				{
					duration: 96,
					easing: 'ease-out',
					fill: 'forwards',
				}
			),
		];
	}

	private pauseAllBackgroundVideos() {
		for ( const video of Array.from( document.querySelectorAll( 'video' ) ) ) {
			if ( video.paused ) {
				continue;
			}

			if ( !isInInertTree( video ) ) {
				continue;
			}

			video.pause();
			this.#pausedVideos.add( video );
		}
	}

	private async unpauseAllBackgroundVideos() {
		for ( const video of Array.from( document.querySelectorAll( 'video' ) ) ) {
			if ( !video.paused ) {
				continue;
			}

			if ( !this.#pausedVideos.has( video ) ) {
				continue;
			}

			if ( isInInertTree( video ) ) {
				continue;
			}

			this.#pausedVideos.delete( video );

			try {
				await video.play();
			} catch ( err ) {
				console.warn( err );
			}
		}
	}
}

customElements.define( 'mr-navigation-overlay', MrNavigationOverlay );

function isInInertTree( el: Element ) {
	if ( el.inert ) {
		return true;
	}

	if ( !el.parentElement ) {
		return false;
	}

	return isInInertTree( el.parentElement );
}
